var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.perms_allow)?_c('v-tooltip',_vm._g(_vm._b({attrs:{"disabled":_vm.$attrs['disabled'] || _vm.$bp.smAndDown || _vm.modal_loader || _vm.$bp.width < 1400,"bottom":_vm.bottom}},'v-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,slot){return _c('template',{slot:[slot]},[_vm._t(slot)],2)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }